<template>
    <div class="common-redpacket-hk26" :class="{ 'common-redpacket-hk26-preview': props.isPreview }">
        <div class="common-redpacket-hk26-content">
            <img :src="state.bull" class="common-redpacket-hk26-content-bull" />
            <a class="common-redpacket-hk26-content-btn" @click="() => props.sendRedpack && props.sendRedpack()">
                开启贺岁红包
            </a>
        </div>
        <img :src="state.title" class="common-redpacket-hk26-title" />
        <div class="common-redpacket-hk26-packet">
            <div class="common-redpacket-hk26-packet-1" />
            <div class="common-redpacket-hk26-packet-2" />
            <div class="common-redpacket-hk26-packet-3" />
        </div>

    </div>
</template>

<script >
import { defineProps, onMounted, reactive } from 'vue-demi';
import { getPcImages } from './config';
const __sfc_main = {};
__sfc_main.props = ['sendRedpack', 'isPreview'];
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const state = reactive({
    bull: '',
    title: ''
  });
  onMounted(async () => {
    const config = await getPcImages();
    state.bull = config.bull;
    state.title = config.title;
  });
  return {
    props,
    state
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.common-redpacket-hk26 {
    width: 100%;
    height: 100vh;
    min-height: 9.7rem;
    position: relative;
    overflow: hidden;
    background: url(../HK2606/images/pc/bg.png) no-repeat center center/100% 100%;

    &-preview {
        height: 9.7rem;
    }

    &-content {
        height: 100%;
        min-height: 10.8rem;
        position: relative;

        &-bull {
            position: absolute;
            width: 7.89rem;
            height: 7.03rem;
            bottom: 0;
            z-index: 10;
            left: 50%;
            transform: translateX(-50%);
        }

        &-btn {
            position: absolute;
            width: 3rem;
            height: 3rem;
            bottom: 0.9rem;
            left: 50%;
            transform: translateX(-50%);
            opacity: 0;
            color: transparent;
            z-index: 11;
        }
    }

    &-title {
        // background-image: url(../HK2606/images/pc/title.png);
        position: absolute;
        width: 7.07rem;
        height: 2.5rem;
        top: 1.27rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 9;
    }

    &-packet {
        position: absolute;
        top: 0;
        width: 8rem;
        height: 100%;
        left: 50%;
        transform: translateX(-50%);
        &-1 {
            position: absolute;
            width: 3.16rem;
            height: 3.2rem;
            right: 0.1rem;
            top: 6rem;
            background: url(./images/pc/packet-1.png) no-repeat center/100% 100%;
            animation: packet1Float 3s ease-in-out infinite;
        }

        &-2 {
            position: absolute;
            width: 4.88rem;
            height: 5.76rem;
            right: -3.5rem;
            top: -2rem;
            background: url(./images/pc/packet-2.png) no-repeat center/100% 100%;
            animation: packet2Float 3.5s ease-in-out infinite;
        }

        &-3 {
            position: absolute;
            width: 3.66rem;
            height: 4.16rem;
            left: -1.5rem;
            top: 3rem;
            background: url(./images/pc/packet-3.png) no-repeat center/100% 100%;
            animation: packet3Float 2.8s ease-in-out infinite;
        }
    }
}

@keyframes packet1Float {

    0%,
    100% {
        transform: translate(0, 0);
    }

    25% {
        transform: translate(0.01rem, -0.18rem);
    }

    50% {
        transform: translate(-0.008rem, -0.3rem);
    }

    75% {
        transform: translate(0.01rem, -0.15rem);
    }
}

@keyframes packet2Float {

    0%,
    100% {
        transform: translate(0, 0);
    }

    25% {
        transform: translate(-0.012rem, -0.22rem);
    }

    50% {
        transform: translate(0.01rem, -0.35rem);
    }

    75% {
        transform: translate(-0.01rem, -0.18rem);
    }
}

@keyframes packet3Float {

    0%,
    100% {
        transform: translate(0, 0);
    }

    25% {
        transform: translate(0.01rem, -0.2rem);
    }

    50% {
        transform: translate(-0.01rem, -0.32rem);
    }

    75% {
        transform: translate(0.008rem, -0.15rem);
    }
}
</style>
